module.exports = __webpack_public_path__ + "img/map1.298b5ff7.png";